import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
//import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm text-black`;
const Heading = tw.span`text-gray-800`;
const Text = styled.div`
  ${tw`text-lg  p-10 text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      
      <Text>
            {/* <p>Elektroniczne etykiety cenowe (ESL) w biurowcach to innowacyjne rozwiązanie, które wychodzi poza tradycyjny kontekst handlowy, znajdując zastosowanie w nowoczesnych przestrzeniach biurowych. Chociaż systemy ESL są najczęściej kojarzone z branżą detaliczną, to w inteligentnych biurach ich implementacja może przynieść szereg korzyści, zarówno z perspektywy zarządzania przestrzenią, jak i optymalizacji procesów.</p> */}

            <h2>Podstawowe korzyści automatyzacji cen w aptece:</h2>
            <h3>1. Zero błędów cenowych.</h3>
            <p>System gwarantuje pełną zgodność cen na półkach z systemem sprzedażowym. Elektroniczne etykiety automatycznie wyświetlają właściwą stawkę – np. cenę z ostatniej dostawy, najniższą lub najwyższą cenę w bazie. Dzięki temu całkowicie eliminujesz ryzyko rozbieżności cenowych oraz wyświetlania nieaktualnych ofert. </p>
  
            <h3>2. Zgodność z regulacjami (m.in. dyrektywa Omnibus)</h3>
            <p>System e-cenówek może automatycznie wyświetlać: aktualną cenę, cenę jednostkową, najniższą cenę z 30 dni (obowiązek Omnibus) oraz właściwe oznaczenia kategorii produktów. Spełnianie obowiązków informacyjnych staje się proste i bezbłędne.
            </p>

            <h3>3. Szybsza obsługa i mniej pracy dla personelu</h3>
            <p>Elektroniczne etykiety cenowe pozwalają:
            <ul>
              <li>- ograniczyć czas poświęcany na zmiany cen nawet o 80–90%,</li>
              <li>- uniknąć konieczności drukowania i wymiany kartek,</li>
              <li>- poświęcić więcej czasu na obsługę pacjenta.</li>
            </ul>
            W czasach niedoboru pracowników automatyzacja to ogromna przewaga.
            </p>

            <h3>4. Lepsza organizacja półek i planogramów</h3>
            <p>System e-cenówki.pl zaawansowane narzędzie umożliwiające centralne wgrywanie planogramów oraz wskazówki dotyczące rozmieszczenia produktów. Apteka zyskuje pełną kontrolę nad układem półek – bez chaosu i pomyłek.
            </p>

            <h3>5. Niższe koszty operacyjne</h3>
            <p>Wdrożenie e-cenówek to inwestycja, która szybko przynosi wymierne oszczędności:
            <ul>
              <li>- brak kosztów druku, papieru, tuszy,</li>
              <li>- mniej błędów cenowych → mniejsze straty,</li>
              <li>- niższe koszty pracy,</li>
              <li>- eliminacja marnowania czasu na ręczne działania.</li>
            </ul>
            W dużych aptekach i sieciach zwrot z inwestycji może nastąpić już po 12–18 miesiącach.
            </p>
          </Text>

      <MainFeature1
        subheading={<Subheading>województwo mazowieckie</Subheading>}
        heading={<Heading>Apteka w Pułtusku</Heading>}
        description = "06-100 Pułtusk ul. Daszyńskiego 9D"
        // buttonRounded={false}
        primaryButtonText="brak filmu >>"
        primaryButtonUrl = "#"
        imageSrc="./IMG_0272.jpg"
        />
       <MainFeature1
        subheading={<Subheading>województwo mazowiecke</Subheading>}
        heading={<Heading>Apteka w Nowym Mieście nad Pilicą</Heading>}
        description = "26-420 Nowe Misto nad Pilicą ul. Tomaszowska 29/33"
        // buttonRounded={false}
        primaryButtonText="brak filmu >>"
        primaryButtonUrl = "#"
        imageSrc="./IMG_9857.jpg"
        textOnLeft={false}
        />
      <MainFeature1
        subheading={<Subheading>województwo mazowieckie</Subheading>}
        heading={<Heading>Apteka w Kobyłce</Heading>}
        description = "05-230 Kobyłka ul. Zagańczyka 3A"
        // buttonRounded={false}
        primaryButtonText="obejrzyj film >>"
        primaryButtonUrl = "https://youtube.com/embed/9aE-bMFxP6s"
        imageSrc="./kobylka.jpg"
        />
      <MainFeature1
        subheading={<Subheading>województwo mazowiecke</Subheading>}
        heading={<Heading>Apteka w Warszawie</Heading>}
        description = "04-454 Warszawa ul. gen. Chruściela 37/39"
        // buttonRounded={false}
        primaryButtonText="obejrzyj film >>"
        primaryButtonUrl = "https://youtu.be/-bHnaWQ6YRk?si=a9VW9tLRTSqvqVOC"
        imageSrc="./chrusciela.jpg"
        textOnLeft={false}
        />
      <MainFeature1
        subheading={<Subheading>województwo pomorskie</Subheading>}
        heading={<Heading>Apteka w Szczecinie</Heading>}
        description = "70-893 Szczecin ul. Tartaczna 14"
        // buttonRounded={false}
        primaryButtonText="obejrzyj film >>"
        //https://youtube.com/shorts/cqlz8MyfB3o?si=-5XBbmqxguplRD7a
        primaryButtonUrl = "https://www.youtube.com/embed/cqlz8MyfB3o"
        imageSrc="./tartaczna.jpg"
        />
      {/* <MainFeature1
        subheading={<Subheading>województwo małopolskie</Subheading>}
        heading={<Heading>Apteka w Inwałdzie</Heading>}
        description = "34-120 Andrychów Inwałd ul. Miła 9"
        // buttonRounded={false}
        primaryButtonText="brak filmu -->"
        primaryButtonUrl = "#"
        imageSrc="./inwałd.jpg"
        textOnLeft={false}
      /> */}
      <MainFeature1
        subheading={<Subheading>województwo małopolskie</Subheading>}
        heading={<Heading>Apteka w Gilowicach</Heading>}
        description = "34-322 Gilowice ul. Krakowska 38"
        // buttonRounded={false}
        primaryButtonText="brak filmu >>"
        primaryButtonUrl = "#"
        imageSrc="./gilowice.jpg"
        textOnLeft={false}
      />
      {/* <MainFeature1
        subheading={<Subheading>województwo pomorskie</Subheading>}
        heading={<Heading>Apteka w Szczecinie</Heading>}
        description = "70-893 Szczecin ul. Tartaczna 14"
        // buttonRounded={false}
        primaryButtonText="obejrzyj film -->"
        primaryButtonUrl = "https://www.youtube.com/embed/cqlz8MyfB3o"
        imageSrc="./tartaczna.jpg"
      /> */}
      {/* <MainFeature1
        subheading={<Subheading>KROK 3 - utrzymanie i serwis</Subheading>}
        heading="Jesteśmy tutaj aby pomagać."
        description ="Dokładamy wszelkich starań, aby nasze aplikacje działały bez zarzutu. Jeśli potrzebujesz zaktualizwoać swoje dane lub potrzebujesz porady dotyczącej Twojej eWizytówki skontaktuj się z naszym ekspertem."
        // buttonRounded={false}
        primaryButtonText="Serwis 24/7"
        primaryButtonUrl = "/serwis"
        imageSrc = "./serwis.jpg"
        textOnLeft={false}
      /> */}
      {/* <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="We follow these."
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
        ]}
        linkText=""
      />
      <TeamCardGrid 
        subheading={<Subheading>Our Team</Subheading>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
};
